import { render, staticRenderFns } from "./clients-location-plan.vue?vue&type=template&id=041008d1"
import script from "./clients-location-plan.vue?vue&type=script&lang=js"
export * from "./clients-location-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports